<template>
  <section class="hero">
    <div class="cover">
      <div class="left">
        <div class="about">
          <h4 class="start">I'm</h4>
          <h1 class="name">Shahroz Saleem</h1>
          <h2 class="profession">Software Engineer</h2>
          <p class="info">
            Detail-oriented Software Engineer and full-stack developer with a
            passion for developing software application with thoughtful UI,
            collaboration, and research.
            <br />
            Specializes in Modern frontend frameworks i.e. <b>Angular</b>,
            <b>VueJs</b>, <b>Material Designs</b>, and backend technologies i.e.
            <b>Spring Boot</b>,
            <b>Node.js</b>
          </p>
          <vs-button size="large" @click="contact">
            Contact
          </vs-button>
          <ul class="socials">
            <li class="links">
              <vs-button icon :href="'mailto:' + email">
                <i class="bx bx-envelope"></i>
              </vs-button>
            </li>
            <li class="links">
              <vs-button icon :href="linkedin">
                <i class="bx bxl-linkedin"></i>
              </vs-button>
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="avatar">
          <img src="@/assets/images/avatar.svg" alt="Avatar" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero",
  data() {
    return {
      linkedin: "http://linkedin.com/in/shahroz-saleem",
      email: "shahrozsaleem17@gmail.com"
    };
  },
  methods: {
    contact() {
      document.querySelector(".contact").scrollIntoView({
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped>
.hero {
  width: 100vw;
  min-height: 100vh;
  height: auto;
}

.hero::before {
  position: absolute;
  content: "";
  background: #f7f7f7;
  width: 20vw;
  height: 70vh;
  left: 25vw;
  z-index: -10;
}

.cover {
  width: 100%;
  height: 750px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-top: 60px;
}

.left {
  width: 50%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.about {
  width: 80%;
  max-width: 600px;
}

.about::before {
  content: "HELLO";
  position: absolute;
  width: auto;
  padding-left: 10px;
  height: 10px;
  font-size: 8vw;
  color: rgba(0, 0, 0, 0.09);
  transform: translateY(-80px);
}

.start {
  font-size: 2em;
  font-weight: normal;
  font-family: Arial, "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  margin: 0px;
}

.name {
  color: #1fa2fa;
  font-size: 5em;
  font-family: "Sacramento", Calibri, Candara, Arial, Helvetica, sans-serif;
  font-weight: normal;
  margin: 0px;
}

.profession {
  transform: translateY(-10px);
  font-size: 2em;
  text-align: right;
  margin: 0.3em;
  font-weight: 500;
}

.profession::before {
  content: "";
  position: absolute;
  background: #1fa2fa;
  width: 15%;
  height: 3px;
  top: 100%;
}

.info {
  padding: 0.2em;
  padding-bottom: 1em;
  line-height: 1.6;
  width: 100%;
}

.socials {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin: 0.5em;
  list-style-type: none;
}

.socials::before {
  content: "";
  background: #1fa2fa;
  width: 25%;
  height: 1px;
  margin: 0px 0.5em;
}

.links {
  margin: 5px;
}

.right {
  width: 50%;
  height: 100%;
  padding: 2em;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 100%;
  height: 100%;
  max-width: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar img {
  width: auto;
  height: 100%;
  box-sizing: border-box;
  object-fit: cover;
}
</style>

<style scoped>
@media screen and (max-width: 1160px) {
  .about::before {
    padding-left: 10px;
    height: 10px;
    font-size: 9vw;
    transform: translateY(-60px);
  }

  .name {
    font-size: 4em;
  }

  .profession {
    font-size: 1.5em;
  }

  .avatar img {
    height: 70%;
  }
}
</style>

<style scoped>
@media screen and (max-width: 1050px) {
  .avatar img {
    height: 60%;
  }
}
</style>

<style scoped>
@media screen and (max-width: 950px) {
  .left {
    width: 100%;
  }

  .about {
    width: 90%;
  }

  .about::before {
    font-size: 130px;
    transform: translateY(-90px);
  }

  .name {
    font-size: 5.5em;
  }

  .profession {
    font-size: 2em;
  }

  .right {
    display: none;
  }
}
</style>

<style scoped>
@media screen and (max-width: 750px) {
  .about::before {
    font-size: 100px;
    transform: translateY(-55px);
  }

  .name {
    font-size: 5em;
  }

  .profession {
    font-size: 1.7em;
  }
}
</style>

<style scoped>
@media screen and (max-width: 650px) {
  .about::before {
    font-size: 90px;
    transform: translateY(-50px);
  }

  .name {
    font-size: 4em;
  }

  .profession {
    font-size: 1.5em;
  }
}
</style>

<style scoped>
@media screen and (max-width: 550px) {
  .about::before {
    font-size: 80px;
    transform: translateY(-40px);
  }

  .name {
    font-size: 4em;
  }

  .profession {
    font-size: 1.5em;
  }
}
</style>
